import { Component, output } from '@angular/core';
import { ReportFilterService } from '../report-filter/report-filter.service';

@Component({
  selector: 'app-report-filter-button',
  templateUrl: './report-filter-button.component.html'
})
export class ReportFilterButtonComponent {
  clearFilterClick = output();

  constructor(
    public _reportFilterService: ReportFilterService,
  ) {

  }

  filterOpen() {
    this._reportFilterService.showFilterPopup = true;
  }

  clearFilter() {
    this.clearFilterClick.emit();
  }
}